import { Grid, MenuItem, TextField } from "@mui/material";
import { useLookupTables } from "../../../../hooks/useLookupTables";
import { DateTime } from "luxon";
import { useMemo, useState } from "react";
import AccountBalanceTable from "./AccountBalanceTable";
import { useAxios } from "../../../../hooks/useAxios";
import PreLoader from "../../../PreLoader";

type Filters = {
  referenceYear: number
}

type Balance = {
  fk_id_currency: number
  currency_sign: string
  month: number
  year: number
  gross_value: number
  due_value: number
  paid_value: number
}

type TotalValues = {
  fk_id_currency: number
  currency_sign: string
  gross_value: number
  due_value: number
  paid_value: number
}

type AccountBalancePerAffiliation = {
  id: number
  affiliation_name: string
  affiliation_tag: string
  balance: Balance[]
  per_grade: {
    fk_id_grade: number
    grade_name: string
    fk_id_currency: number
    currency_sign: string
    month: number
    year: number
    gross_value: number
    due_value: number
    paid_value: number
  }[]
  total: TotalValues[]
  spring_total: TotalValues[]
  fall_total: TotalValues[]
}

export type Data = {
  groupedAccountBalance: AccountBalancePerAffiliation[]
  yearTotal: TotalValues[]
  springTotal: TotalValues[]
  fallTotal: TotalValues[]
  perGradeTotal: {
    fk_id_affiliation: number
    affiliation_name: string
    fk_id_grade: number
    grade_name: string
    fk_id_currency: number
    currency_sign: string
    gross_value: number
    due_value: number
    paid_value: number
  }[]
  monthlyTotal: Balance[]
}

export default function AccountBalance() {
  const { lookupTables } = useLookupTables(['referenceYearForBillings'])
  // Filters
  const [filters, setFilters] = useState<Filters>({
    referenceYear: DateTime.utc().get('year')
  })
  // Memos
  const months = useMemo(() => {
    const _months: DateTime[] = []

    var startMonth = DateTime.fromObject({ year: filters.referenceYear, month: 1, day: 1 })
    var endMonth = DateTime.fromObject({ year: filters.referenceYear, month: 12, day: 1 })

    var currentMonth = startMonth

    while (currentMonth.diff(endMonth).milliseconds <= 0 && _months.length <= 12) {
      _months.push(currentMonth)

      currentMonth = currentMonth.plus({ month: 1 })
    }

    return _months
  }, [filters])

  const url = useMemo(() => {
    const qs: string[] = []

    qs.push(`year=${filters.referenceYear}`)

    return `${process.env.REACT_APP_MAIN_BACKEND_URL}/account-balance?${qs.join('&')}`
  }, [filters])

  const { data, error, isLoading } = useAxios<Data>(url)

  console.log(data)

  if (isLoading) return <PreLoader />

  if (error || !data) return <>Error</>

  return <>
    {/* Filters */}
    <Grid item xs={2}>
      <TextField
        id='filter-reference-year'
        label='Reference year'
        value={filters.referenceYear}
        onChange={(e) => setFilters((_filters) => ({ ..._filters, referenceYear: Number(e.target.value) }))}
        select
      >
        {
          // Years with billings, plus the current and the next one (rollout)
          Array.from(new Set([...(lookupTables?.referenceYearForBillings || []), DateTime.utc().year, DateTime.utc().year + 1])).sort().map((year, index) => <MenuItem key={index} value={year}>{year}</MenuItem>)
        }
      </TextField>
    </Grid>
    {/* Table */}
    <Grid item xs={12} maxHeight={'75vh'}>
      <AccountBalanceTable
        data={data}
        months={months}
      />
    </Grid>
  </>
}
